import { render, staticRenderFns } from "./add-version.vue?vue&type=template&id=b5247e84&scoped=true"
import script from "./add-version.vue?vue&type=script&lang=js"
export * from "./add-version.vue?vue&type=script&lang=js"
import style0 from "./add-version.vue?vue&type=style&index=0&id=b5247e84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5247e84",
  null
  
)

export default component.exports